import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';
import { useMediaQuery } from '@oneaudi/feature-app-utils';

export const useIsMobile = () => {
  return useMediaQuery(`(max-width: ${SYS_BREAKPOINT_MD})`);
};
